import Vue from 'vue';
import { apolloClient } from '@/plugins/vue-apollo';
import {
  searchOrganizationsQuery,
  publicProfileQuery,
} from '@/store/graphql/queries/organization';

export default {
  namespaced: true,
  state: {
    organizations: [],
    organization: null,
  },
  actions: {
    async get({ commit }, organizationId) {
      try {
        const getQuery = {
          query: publicProfileQuery,
          variables: {
            organizationId,
          },
        };

        const response = await apolloClient.query(getQuery);
        if (response && response.data) {
          commit('SET_ORGANIZATION', response.data.organization_by_pk);
        }
      } catch (error) {
        window.console.error(error);
      }
    },
    async search({ commit, state }, keyword) {
      try {
        const searchQuery = {
          query: searchOrganizationsQuery,
          variables: {
            keyword: `%${keyword}%`,
          },
        };
        const response = await apolloClient.query(searchQuery);
        if (response && response.data) {
          commit('SET_ORGANIZATIONS', response.data.organization);
        }
      } catch (error) {
        window.console.error(error);
      }
      return state.organizations;
    },
  },
  mutations: {
    SET_ORGANIZATION(state, data) {
      Vue.set(state, 'organization', data);
    },
    SET_ORGANIZATIONS(state, data) {
      Vue.set(state, 'organizations', data);
    },
  },
  getters: {
    organizationsInfo: state => state.organizations,
    organizationInfo: state => state.organization,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/core/organization.js